<template>
    <v-menu
        v-model="menu_date_picker"
        :close-on-content-click="false"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        min-width="290px"
        :disabled="!!disabled"
        :class="{ 'prevent-click': disabled }"
    >
        <template slot="activator">
            <v-text-field
                v-focus="focus ? focus : false"
                v-model="current_value"
                v-bind="$attrs"
                v-on="$listeners"
                :label="$attrs.label ? $attrs.label : $t('lang.date')"
                :append-icon="$attrs['append-icon'] ? $attrs['append-icon'] : 'event'"
                :class="{ 'prevent-click': disabled, inputClass }"
                readonly
                :prepend-icon="$attrs['prepend-icon'] ? $attrs['prepend-icon'] : ''"
                :prepend-inner-icon="$attrs['prepend-inner-icon'] ? $attrs['prepend-inner-icon'] : ''"
                :append-outer-icon="$attrs['append-outer-icon'] ? $attrs['append-outer-icon'] : ''"
                :style="$attrs['max-width'] ? `max-width: ${$attrs['max-width']}px` : ''"
                :disabled="$attrs['is_disabled'] ? $attrs['is_disabled'] : false"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="current_value"
            :locale="current_user && current_user.language && localeCodes ? localeCodes[current_user.language] : 'un-US'"
            @input="update($event)"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ["focus", "value", "inputClass", "disabled"],
    data() {
        return {
            menu_date_picker: false,
        };
    },
    computed: {
        ...mapGetters(["localeCodes"]),
        current_value: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit("input", val);
            },
        },
    },
    methods: {
        update($event) {
            this.menu_date_picker = false;
            this.$emit("update", $event);
        },
    },
};
</script>
